import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useBreakpoint } from '@app/hooks';
import cx from 'classnames';
import { PAGE_BREAKPOINTS, STATUS } from '@app/constants/commonConstants';
import { getFbtTotalPrice } from '@app/store/products/actions';
import AddTheseToCart from './AddTheseToCart';
import CurrentItem from './CurrentItem';
import FbtItems from './FbtItems';

const FrequentlyBoughtTogether = ({ getFitmentResult, model }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [selectedItems, setSelectedItems] = useState([]);
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const current = useSelector(s => s.products?.current);
  const partNumber = useSelector(s => s.products?.byId?.[current]?.partNumber);
  const currentPriceStatus = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.loadingStatus
  );
  const isPriceCallComplete =
    currentPriceStatus === STATUS.RESOLVED ||
    currentPriceStatus === STATUS.REJECTED;
  const fbtPriceAndAvailability = useSelector(
    s => s.products?.fbtPriceAndAvailability
  );
  const isCatCorp = useSelector(s => s.common?.isCatCorp);

  const handleCheckBox = useCallback(
    (id, val) => {
      if (!val) {
        setSelectedItems(prev => [...prev, { id, val }]);
      } else {
        const selected = selectedItems.filter(item => item.id !== id);
        setSelectedItems(selected);
      }
    },
    [selectedItems]
  );

  // Trigger subtotal api on checkbox onchange
  useEffect(() => {
    if (isPriceCallComplete) {
      selectedItems?.length > 0
        ? !isCatCorp && dispatch(getFbtTotalPrice(selectedItems, isLG))
        : fbtPriceAndAvailability &&
          !isCatCorp &&
          dispatch(getFbtTotalPrice(null, isLG));
    }
  }, [
    isPriceCallComplete,
    selectedItems,
    dispatch,
    fbtPriceAndAvailability,
    isCatCorp,
    isLG
  ]);

  return (
    <div className="my-4" id="pdp-fbt-items-container">
      <h2 className="h6 u-color--ExtraDarkGray text-uppercase">
        {t('FREQUENTLY_BOUGHT_TOGETHER')}
      </h2>
      <div className="d-flex flex-wrap justify-content-between">
        <CurrentItem
          getFitmentResult={getFitmentResult}
          handleCheckBox={handleCheckBox}
        />
        <FbtItems
          getFitmentResult={getFitmentResult}
          model={model}
          handleCheckBox={handleCheckBox}
        />
      </div>
      <div
        className={cx(
          { 'flex-column justify-content-center': !isMD },
          'd-flex justify-content-end'
        )}
      >
        {!isCatCorp && <AddTheseToCart selectedItems={selectedItems} />}
      </div>
    </div>
  );
};

FrequentlyBoughtTogether.propTypes = {
  getFitmentResult: PropTypes.func,
  model: PropTypes.string
};

export default FrequentlyBoughtTogether;
